/**
 * RISKS-TABS.CONFIG
 * Shared tabs configuration for risks navigation
 */

import { faSitemap, faExclamationTriangle, faFileAlt } from "@fortawesome/free-solid-svg-icons"

export const RISKS_TABS = [
  {
    id: "/risks",
    label: "Fiches de risques",
    icon: faExclamationTriangle
  },
  {
    id: "/risks/document",
    label: "Document unique",
    icon: faFileAlt
  },
  {
    id: "/risks/units",
    label: "Unités de travail",
    icon: faSitemap
  }
]
